import { glnData } from '@markant-platform/shared/organization/model';

export function getGlnString(glns: glnData[]): string {
  return glns.map(gln => gln.value).join(', ');
}
